import { CommentField, Button, Grid, Rating, Stack } from '@gogame/components';

import { ID, TEXT, MARK } from './constants';
import { useCommentWithMarkState } from './useCommentWithMarkState';

const CommentWithMarkForm = ({
  initialValue,
  onChange,
  onCancel,
  autoFocus,
  label,
}) => {
  const {
    markField,
    commentField,
    open,
    onCancel: cancel,
    isTextValid,
    isMarkValid,
    dirty,
  } = useCommentWithMarkState({
    initialText: initialValue[TEXT],
    initialMark: initialValue[MARK],
  });

  const handleCancel = () => {
    cancel();
    onCancel && onCancel();
  };
  const handleSave = () => {
    const value = {
      comment: commentField?.value,
      mark: markField?.value,
      ...(initialValue[ID] && {
        [ID]: initialValue[ID],
      }),
    };
    if (isTextValid() && isMarkValid() && onChange) {
      onChange(
        {
          target: {
            value,
          },
        },
        value
      );
      cancel();
    }
  };

  return (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid item xs={12}>
        <CommentField
          {...commentField}
          label={label}
          name={'text'}
          autoFocus={autoFocus}
        />
      </Grid>

      {open || dirty ? (
        <>
          <Grid item xs={6}>
            <Rating name={'mark'} size={'medium'} padding={0} {...markField} />
          </Grid>
          <Grid item xs={6}>
            <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button
                onClick={handleSave}
                disabled={!dirty}
                variant={'contained'}
              >
                Save
              </Button>
            </Stack>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};
export default CommentWithMarkForm;
